import * as yup from 'yup';

import errorText from './validationTexts';

export const vehicleInfoSchema = yup.object().shape({
    vehicleRegistrationNumber: yup
        .string()
        .trim()
        .min(6, errorText.regNoRequired)
        .max(7, errorText.regNoRequired)
        .typeError(errorText.regNoRequired)
        .required(errorText.regNoRequired),

    odometerValue: yup.lazy((value) => {
        if (value !== undefined) {
            return yup
                .number()
                .integer(errorText.odometerValueRequired)
                .typeError(errorText.odometerValueRequired)
                .required(errorText.odometerValueRequired);
        }
        return yup.number().notRequired();
    }),
});
export default { vehicleInfoSchema };
